import React, { useState, useContext, useEffect } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import AboutMarketSignalsSection from './AboutMarketSignalsSection/AboutMarketSignalsSection';
import TheSignals from './TheSignals/TheSignals';
import WhyToCare from './WhyToCare/WhyToCare';
import WhatSignalsWeLookFor from './WhatSignalsWeLookFor/WhatSignalsWeLookFor';
import './style.css';
import { AreaDataContext } from '/src/Views/PropertyExplorer/PropertyExplorer';
import { AddressSearchContext } from '/src/App';
import { usePropertyGaLogging } from '/src/contexts/PropertyGaLoggingContext';


const LTVMarketSignals = ({ propertyData, marketDataKeys, housingMarketData, ltvInfo }) => {

    const { geoData } = useContext(AreaDataContext);
    // const { LOG_GA_EVENT } = useContext(AddressSearchContext);
    const { handleLoggingGaEventFromProperty } = usePropertyGaLogging();
    // console.log('housingMarketData from LTVMarketSignals.jsx', housingMarketData);
    // console.log('geoData from LTVMarketSignals.jsx', geoData);
    const fipsData = geoData?.fipsData

    const originalValuesFromHousingMarketData = housingMarketData?.originalValues
    const disasterDeclarations = originalValuesFromHousingMarketData?.disasterDeclarations
    const disasterDeclarationsState = originalValuesFromHousingMarketData?.disasterDeclarationsState
    const disasterDeclarationsStateAllCounties = originalValuesFromHousingMarketData?.disasterDeclarationsStateAllCounties
    const refinedMarketData = housingMarketData?.refinedMarketData
    const refinedFipsMarketData = refinedMarketData?.fipsHousingMarketData
    const refinedZipMarketData = refinedMarketData?.zipHousingMarketData

    const [currentStage, setCurrentStage] = useState(0);

    const stages = [
        {
            id: 0,
            title: "Why are climate signals in the market so important?",
            description: "We've talked about this home's expenses as the homeowner, but now we need to put ourselves in a potential buyer's shoes. Remember, they will need to be able to afford the recurring expenses for this home plus whatever mortgage costs they take on. The question is, at what point do those combined costs become too high and start to push down the value of this home?"
        },
        {
            id: 1,
            title: "What signals are we looking for and how do we spot them?",
            description: "We've talked about this home's expenses as the homeowner, but now we need to put ourselves in a potential buyer's shoes. Remember, they will need to be able to afford the recurring expenses for this home plus whatever mortgage costs they take on. The question is, at what point do those combined costs become too high and start to push down the value of this home?"
        },
        {
            id: 2,
            title: "What do we see in this home's local market?",
            description: "We've talked about this home's expenses as the homeowner, but now we need to put ourselves in a potential buyer's shoes. Remember, they will need to be able to afford the recurring expenses for this home plus whatever mortgage costs they take on. The question is, at what point do those combined costs become too high and start to push down the value of this home?"
        },
        {
            id: 3,
            title: "Breaking down the signals",
            description: "There are obviously many factors that draw a buyer to a home, but from a strictly financial standpoint, being able to afford the costs of the home is the basic threshold that must be met. While some buyers may be willing tospend more than 30%, doing so would mean stretching themselves thin..."
        },

    ]

    // useEffect to log when the stage changes
    useEffect(() => {
        const GALogEventId = `ltv_market_forces_step_${currentStage+1}`;
        handleLoggingGaEventFromProperty(GALogEventId);
    }, [currentStage]); 

    const handleNavigate = (direction) => {
        let newStage;
        if (direction === 'next') {
            newStage = currentStage + 1;
        } else if (direction === 'prev') {
            newStage = currentStage - 1;
        }

        if (newStage >= 0 && newStage <= stages.length) {
            setCurrentStage(newStage);

            // Add smooth scrolling
            const container = document.querySelector('.ltv-section-container');
            if (container) {
                container.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    };

    const currentStageData = stages.find(stage => stage.id === currentStage);


    return (
        <div className="ltv-section-container">
            <div className="ltv-section-container-header">
                <div className="ltv-section-container-header-text">
                    <span>{ltvInfo.title}</span>
                </div>
                <button className={`ltv-section-container-header-rating ${ltvInfo.riskLevelCSSClass}`}>
                    {ltvInfo.riskLevelText}
                </button>
            </div>
            <div className="ltv-section-container-content">
                {/* <h2 className="ltv-attractiveness-title">{currentStageData.title}</h2> */}
                {currentStage === 0 && (
                    <WhyToCare
                        title={currentStageData.title}
                    />
                )}
                {currentStage === 1 && (
                    <WhatSignalsWeLookFor
                        title={currentStageData.title}
                    />
                )}
                {currentStage === 2 && (
                    <AboutMarketSignalsSection
                        title={currentStageData.title}
                        disasterDeclarations={disasterDeclarations}
                        disasterDeclarationsState={disasterDeclarationsState}
                        disasterDeclarationsStateAllCounties={disasterDeclarationsStateAllCounties}
                        marketDataKeys={marketDataKeys}
                        fipsData={fipsData}
                        propertyData={propertyData}
                        housingMarketData={housingMarketData}
                    />
                )}
                {currentStage === 3 && (
                    <TheSignals
                        housingMarketData={housingMarketData}
                        title={currentStageData.title}
                        propertyData={propertyData}
                        disasterDeclarations={disasterDeclarations}
                        disasterDeclarationsState={disasterDeclarationsState}
                    />
                )}
                <nav className="ltv-attractiveness-navigation">
                    {currentStage > 0 && (
                        <button
                            className="ltv-attractiveness-nav-button prev"
                            onClick={() => handleNavigate('prev')}
                        >
                            <ArrowLeft />
                            <span className='text-align-center'>{stages[currentStage - 1].title}</span>
                        </button>
                    )}

                    {currentStage < stages.length - 1 && (
                        <button
                            className="ltv-attractiveness-nav-button next"
                            onClick={() => handleNavigate('next')}
                        >
                            <span className='text-align-center'>{stages[currentStage + 1].title}</span>
                            <ArrowRight />
                        </button>
                    )}
                </nav>
            </div>
        </div>
    );
};

export default LTVMarketSignals;